import * as React from "react";
import { Check, Circle } from "./icons";

import { cn } from "utils/cn";
import { PASSWORD_RULES } from "utils/passwordPolicy";

export interface PasswordChecklistProps {
  password: string;
  className?: string;
}

/** Live list of password requirements; each turns green once met. */
export const PasswordChecklist: React.FC<PasswordChecklistProps> = ({ password, className }) => (
  <ul
    data-ui="password-checklist"
    aria-label="Password requirements"
    className={cn("grid grid-cols-1 gap-x-4 gap-y-1.5 text-xs sm:grid-cols-2", className)}
  >
    {PASSWORD_RULES.map((rule) => {
      const met = rule.test(password);
      return (
        <li
          key={rule.id}
          className={cn(
            "flex items-center gap-1.5 transition-colors duration-fast",
            met ? "text-success-text" : "text-muted-foreground"
          )}
        >
          {met ? (
            <Check aria-hidden="true" className="h-3.5 w-3.5" weight="bold" />
          ) : (
            <Circle aria-hidden="true" className="h-3.5 w-3.5 opacity-50" />
          )}
          <span>{rule.label}</span>
          <span className="sr-only">{met ? "(met)" : "(not met)"}</span>
        </li>
      );
    })}
  </ul>
);
